__turbopack_context__.v({
  "bar": "styles-module-scss-module__KkaLta__bar",
  "barWrapper": "styles-module-scss-module__KkaLta__barWrapper",
  "container": "styles-module-scss-module__KkaLta__container",
  "marker": "styles-module-scss-module__KkaLta__marker",
  "positionLabel": "styles-module-scss-module__KkaLta__positionLabel",
  "priceBarFade": "styles-module-scss-module__KkaLta__priceBarFade",
});
